"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTabButton = void 0;
var TabButton_style_1 = __importDefault(require("./TabButton.style"));
function useTabButton(_a) {
    var isSelected = _a.isSelected;
    var hoverVariant = isSelected ? undefined : 'default';
    return {
        classes: (0, TabButton_style_1.default)(),
        hoverVariant: hoverVariant,
    };
}
exports.useTabButton = useTabButton;
